import React, { useState, useEffect, useRef } from "react";
import _ from "lodash";
import { useSelector, useDispatch } from "react-redux";
import {
  getLicense,
  deleteSaveLicense,
  saveLicense,
} from "../Actions/licenseAction";
import Header from "./Header";
import Sidebar from "./Sidebar";
import CandidateTab from "./CandidateTab";
import NotificationPanels from "./NotificationPanels";
import "../assets/css/candidate-tab-form.css";
import "../assets/css/inner-tabs.css";
import Footer from "./Footer.js";
import { useNavigate } from "react-router-dom";
import {
  getEducation,
  updateCampusHireEducation,
} from "../Actions/educationActions";
import { updateLicenseRequire } from "../Actions/licenseAction";
import MainForm from "./LicenseForm/MainForm";
import QuestionForm from "./LicenseForm/QuestionForm";
import StepCount from "./Common/StepCount";
import { removeFile } from "../Actions/uploadFileActions";
import { useParams } from "react-router-dom";
import { createGlobalStyle } from "styled-components";
import Loader from "./Common/loader";
import ClientSideBar from "./Partials/ClientSideBar";
import ClientHeader from "./Partials/ClientHeader";
import ProgressHeading from "./Common/ProgressHeading.jsx";

const LicenseCheck = () => {
  let { activeTab } = useParams();
  const form = useRef();

  const [data, setData] = useState([]);
  const [radioSelect, setRadioSelect] = useState();
  const [initialRadioSelect, setInitialRadioSelect] = useState();
  const [formState, setFormState] = useState(false);
  const [licenseRequire, setLicenseRequire] = useState(1);
  const [noSelect, setNoSelect] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const storeLicenseData = useSelector((state) => state.license);
  const [role,setRole]=useState();

  const [unsavedLicData, setUnsavedLicData] = useState({});
  const [formError, setFormError] = useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { licenseData, loadingData, error } = storeLicenseData;
  console.log(licenseData);

  const autoLoginStore = useSelector((state) => state.autoLogin);
  const { autoLoginData, loadingLogin } = autoLoginStore;

  useEffect(() => {
    if (
      typeof autoLoginData?.status !== "undefined" &&
      autoLoginData?.status !== null
    ) {
      
     setRole(autoLoginData.data.user_role);
    }
  }, [autoLoginData, autoLoginStore]);


  useEffect(() => {
    if (typeof licenseData?.data !== "undefined" && licenseData?.data !== null) {
      if (Object.keys(unsavedLicData).length == 0) {
     // debugger
        console.log("lic", licenseData);
        setData(licenseData.data.data);
      } else {
       //debugger
        console.log("lic", unsavedLicData);
        console.log("lic", licenseData);
        const updatedData = licenseData.data.data;
        let newData = _.cloneDeep(unsavedLicData);
        let checksDetailsMain = _.cloneDeep(newData.checksDetails);
        let updatedChecksDetails = _.cloneDeep(updatedData.checksDetails);
        const checksDetailsMainLength = checksDetailsMain.length;
        const updatedChecksDetailsLength = updatedChecksDetails.length;
        if (checksDetailsMainLength == updatedChecksDetailsLength) {
          for (var i in checksDetailsMain) {
            checksDetailsMain[i]["uploaded_documents"] = updatedChecksDetails[i]
              .uploaded_documents
              ? updatedChecksDetails[i].uploaded_documents
              : [];
            checksDetailsMain[i]["uploaded_instant_documents"] =
              updatedChecksDetails[i].uploaded_instant_documents
                ? updatedChecksDetails[i].uploaded_instant_documents
                : [];
          }
        } else if (updatedChecksDetailsLength > checksDetailsMainLength) {
          checksDetailsMain.push(
            updatedChecksDetails[updatedChecksDetailsLength - 1]
          );
        } else {
          let checkToBeRemovedIndex = null;
          for (let i = 0; i < checksDetailsMain.length; i++) {
            let isCheckPresent = false;
            for (let j = 0; j < updatedChecksDetails.length; j++) {
              if (
                checksDetailsMain[i].case_check_id ==
                updatedChecksDetails[j].case_check_id
              ) {
                isCheckPresent = true;
                break;
              }
            }
            if (!isCheckPresent) {
              checkToBeRemovedIndex = i;
            }
          }
          if (checkToBeRemovedIndex) {
            let newChecksDetails = [];
            for (let i = 0; i < checksDetailsMain.length; i++) {
              if (i != checkToBeRemovedIndex) {
                newChecksDetails.push(checksDetailsMain[i]);
              }
            }
            checksDetailsMain = _.cloneDeep(newChecksDetails);
          }
        }

        newData.checksDetails = _.cloneDeep(checksDetailsMain);
        
        setData(newData);
      }

      if (licenseData.data.data.checksDetails[0].check_status == 2) {
        setLicenseRequire(2);
        
        if(radioSelect==undefined){
        setInitialRadioSelect(
          licenseData.data.data.checksDetails[0].fields
            .qualification_require_license.field_value
        );
        }
      }

      //setLicenseRequire(licenseData.data.data.checksDetails[0].show_check);
    }
  }, [licenseData, storeLicenseData]);

  console.log(data);
  // console.log(data.checksDetails[0].case_check_id);

  useEffect(() => {
    const fetchData = async () => {
      dispatch(getLicense());
    };

    fetchData();
  }, []);

  const licenseRequireStatusHandler = (record) => {
    console.log(record);
    // dispatch(updateLicenseRequire(record.licenseRequire));
    setLicenseRequire(record.licenseRequire);
    //  reRenderAgain();
  };

  //question select handler
  const reRenderAgain = (value) => {
    setUnsavedLicData(value);
    dispatch(getLicense());
  };

  const reRenderAgain2 = (value) => {
    dispatch(getLicense());
  };

  const setValue = (e) => {
    var cols = document.getElementById('err-find');
    cols.innerHTML = '';
    setRadioSelect(e.target.value);
    setInitialRadioSelect(e.target.value);
    console.log(radioSelect + "158")
    console.log(initialRadioSelect + "159")
  };

  const proceedDelete = (data) => {
    
const recordArray = {};
    recordArray.doc_chk = data?.case_check_id;
    recordArray.doc_ids = data?.uploaded_documents[0]?.document_id;
    recordArray.doc_ref = "all";

    //calling file upload api
    dispatch(removeFile("check_documents", recordArray));
  };
  const storeLicenseSave = useSelector((state) => state.licenseSave);
  const { licenseSaveData,loading: saveLoading, error: saveError } = storeLicenseSave;
  console.log(licenseSaveData);

   useEffect(() => {
    if (typeof saveLoading !== "undefined" && saveLoading !== null) {
      if (saveLoading === true) {
        setIsLoading(true);
      } else {
        setIsLoading(false);
        //  reRenderAgain();
      }

    }
  }, [saveLoading]);
  const formValidation = (radioSelect) => {

    const errors = {};
    let isError = false;

    var cols = document.getElementsByClassName('err text-danger');
    for (let i = 0; i < cols.length; i++) {
      cols[i].innerHTML = '';
    }

    if(radioSelect==undefined && initialRadioSelect==undefined){
      console.log('d',radioSelect);
      
      document.getElementById('err-find').innerHTML = "This field is required.";
      isError=true;
    }

    return isError;

  }
  
  const handleSave1 = () => {
    console.log("e",radioSelect);
    const err = formValidation(radioSelect);
    console.log("fr",err);
    if (err === true) {
      setFormError(err);

      window.scroll({ top: 0, left: 0, behavior: "smooth" });
    }

    if (radioSelect == "No" || initialRadioSelect == "No") {
      const recordData = {};

      //recordData.case_check_id = caseCheckId;

      // const obj = {
      //   case_check_id: data.checksDetails[0].case_check_id,
      //   check_data: {
      //     [`${data.checksDetails[0].case_check_id}`]: {
      //       group: "prof_license",
      //       235: "No",
      //     },
      //   },
      // };
      const obj = _.cloneDeep(data.checksDetails);
      const o = {};
      for (var i in obj[0].fields) {
        if (i === "qualification_require_license") {
          
          obj[0].fields[i].field_value = radioSelect;
          o[obj[0].fields[i].id] = radioSelect;
        } else {
         
          obj[0].fields[i].field_value = "";
          o[obj[0].fields[i].id] = "";
        }
      }
      if(data.checksDetails[0].uploaded_documents){
        proceedDelete(data.checksDetails[0]);
      } 
      const obj2 = { group: "prof_license", ...o };
      recordData.case_check_id = obj[0].case_check_id;
      recordData.check_data = { [obj[0].case_check_id]: obj2 };
     
     // setUnsavedLicData({});
     // console.log("lic", unsavedLicData);
  
      dispatch(saveLicense(recordData));
    }
  };
  useEffect(() => {
    
    if (typeof licenseSaveData !== "undefined" && licenseSaveData !== null) {
      const group = licenseSaveData.group ? licenseSaveData.group.group_id : '';
      if (group == 'profile_preview') {
      navigate(
        `/case-initiation/profile-preview/${data.referenceNo}`
      );
      dispatch(deleteSaveLicense());
   
      }
       else if (typeof group != "undefined" && group != '') {
      navigate(
        `/case-initiation/check-detail/${data.referenceNo}/${group}`
      );
      dispatch(deleteSaveLicense());  
   
      }
   }
  }, [licenseSaveData, storeLicenseSave]);
 
  console.log("rt",data);
  return (
    <>
    {isLoading && <Loader />}
      <NotificationPanels />
      {role=="EP"? <ClientHeader />:<Header/>}
      {role=="EP"? <ClientSideBar /> :<Sidebar/>}
      {/* <Header />
      <Sidebar /> */}
      <section
        className="main-section candidate-tab-form"
        style={{ paddingTop: "60px" }}
      >
        <div className="container-fluid">
          <div className="row">
            <div className="col-auto bg-gray-mbl">
              <ProgressHeading/>
              <CandidateTab activeTab={"Professional License"} />
            </div>
            <div className="col bg-gray-mbl">
              <br />
              <StepCount activeTab={"Professional License"} />
              <h2 className="fnt-smi-bld">Professional License Check</h2>
              <p className="text-muted">
                Detail about your qualification which requires license to
                practice like CA, Doctor, lawyer etc.
              </p>
              <hr />
              <div>
                {" "}
                <h6 className="fnt-smi-bld mb-3">
                  Do you have any qualification which requires license to
                  practice like CA, Doctor, lawyer etc.
                </h6>
                <div className="row mb-3">
                  <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-check form-check-inline mr-4">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="referenceCheckYesNo"
                        id="referenceCheckYes"
                        value="Yes"
                        checked={
                          radioSelect
                            ? radioSelect === "Yes"
                              ? true
                              : false
                            : initialRadioSelect === "Yes"
                            ? true
                            : false
                        }
                        onChange={setValue}
                      />
                      <label
                        htmlFor="referenceCheckYes"
                        className="form-check-label"
                      >
                        Yes
                      </label>
                    </div>

                    <div className="form-check form-check-inline">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="referenceCheckYesNo"
                        id="referenceCheckNo"
                        value="No"
                        checked={
                          radioSelect
                            ? radioSelect === "No"
                              ? true
                              : false
                            : initialRadioSelect === "No"
                            ? true
                            : false
                        }
                        onChange={setValue}
                      />
                      <label
                        htmlFor="referenceCheckNo"
                        className="form-check-label"
                      >
                        No
                      </label>
                    </div>
                    <p className="err text-danger" id="err-find">{formError.formVal1}</p>
                  </div>
                  
                </div>
              </div>

              {data.checksDetails &&
              // data.checksDetails[0].fields.qualification_require_license.field_value === "Yes" ||
              (radioSelect === "Yes" || initialRadioSelect === "Yes") ? (
                <>
                  <MainForm
                    license={data}
                    reRenderAgain={reRenderAgain}
                    reRenderAgain2={reRenderAgain2}
                    active={activeTab}
                    radioSelect={radioSelect}
                    initialRadioSelect={initialRadioSelect}
                  />
                </>
              ) : (
                <>
                  <div className="row mt-3">
                    <div className="col-auto d-flex justify-content-between">
                      <button
                        className="btn btn-primary btn-lg btn-block mt-3"
                        onClick={handleSave1}
                      >
                        Save
                      </button>

                      {/* )} */}
                      {console.log(licenseRequire)}
                    </div>
                  </div>
                </>
              )}

              {/* {console.log(licenseRequire)}
                </div> */}
              {/* </div> : ""} */}
              {/*Form*/}
              {/* <form ref={form} className="p-3 form2 form-section" style={{ minHeight: '700px' }}> */}

              {/* </form> */}
              {/*Form*/}
              {/* <div className="mt-4">
                <div className="row mb-3">
                  <div className="col-md-12 d-flex align-items-center btn-and-info-responsive">
                    <button className="btn btn-primary btn-lg mr-3">Submit for Preview</button>
                    <span className="text-muted">Please complete the all mandatory fields before final submission</span>
                  </div>
                </div>
              </div> */}
              <Footer />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default LicenseCheck;